import type { FunctionComponent, } from "react"
import styled from "styled-components"
import { Text as Tx, type Variant, type FontWeight, } from "@bracket/ui";
import type { Decimal, } from "@bracket/prisma/types";



export declare type BigIntValueProps = {
	value: bigint | Decimal;
	type?: "percent"|"dollars"|"normal";
	prefix?: string;
	decimals?: number;
	suffix?: string;
	precision?: number;
	variant?: Variant;
	fontWeight?: FontWeight;
};


/**
 * Render a bigint value either as dollars, percent or a normal 5 point precision. The bigint is assumed to be ^18
 * @todo allow for other multiplicites
 * @param {bigint} the value
 * @returns 
 */
export const BigIntValue: FunctionComponent<BigIntValueProps> = ({
	value,
	type = "normal",
	prefix = "",
	suffix = "",
	precision = 5,
	decimals = 18,
	variant = "p",
	fontWeight,
}) => {

	const formatted = (): string => {
		switch(type) {
			case "dollars":
				return `${prefix}${value.toLocaleString("en-US", { style: "currency", currency: "USD", })}${suffix}`;
			case "percent": {
				const valnum = Number(value) / (10**decimals);
				return `${prefix}${precision ? `${valnum.toFixed(precision)}%` : `${valnum}%`}${suffix}`;
			}
			case "normal": {
				const valnum = Number(value) / (10**decimals);
				return `${prefix}${precision ? `${valnum.toFixed(precision)}` : `${valnum}`}${suffix}`;
			}
			default:
				throw new Error(`BigIntValue - unknown type "${type}"`)
		}
	};

	return (
		<Brace>
			<Tx size={variant} weight={fontWeight}>{formatted()}</Tx>
		</Brace>
	);

}


const Brace = styled.div`

`
